import logo from "../assets/logo.png";
import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

export default function Footer({ lang }: Props) {
  const tr = t[lang].footer;

  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src={logo} alt="MyLittleMouse" className="footer-logo-img" />
        MyLittleMouse
      </div>
      <div className="footer-links">
        <a href="mailto:mineporia@gmail.com">{tr.support}</a>
      </div>
      <p className="footer-copy">© {new Date().getFullYear()} MyLittleMouse. {tr.rights}</p>
    </footer>
  );
}
